import styled from "styled-components";
import { media } from "../../../../layouts/utils";
import {
  TituloH1 as TituloPrincipal,
  Descricao,
} from "../../../../components/TituloSorriso/styles";
import { fontFamily } from "src/global.style";

export const Wrapper = styled.div`
  ${media.phone`
    height: content-fit;
    min-height: 500px;
    padding-left: 10px;
    padding-right: 10px;
  `}
  ${media.smallPhone`
    height: content-fit;
    min-height: 500px;
    padding-left: 10px;
    padding-right: 10px;
`}
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 450px;
  padding-top: 40px;
  background: transparent
    linear-gradient(0deg, #000000 0%, #000000 69%, #000000 100%) 0% 0% no-repeat
    padding-box;
`;

export const Container = styled.div`
  max-width: 520px;
  height: auto;
`;

export const Content = styled.div`
  position: relative;
  z-index: 1;
  top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Background = styled.img`
  position: absolute;
  z-index: 0;
  top: 0;
  bottom: 0;
  left: 0;
  background-image: cover;
  width: 100%;
  height: 100%;
  ${media.phone`
    width: 200%;
    height: 100%;
    left: -48%;
    top: 0;
  `}
  opacity: 0.7;
`;

export const TextIntro = styled(Descricao)`
  font-weight: 700;
  font-size: 0.75rem;
  color: ${(props) => props.cor};
  text-transform: uppercase;
  font-size: 16px;
  line-height: 20px;
`;

export const TitleContainer = styled.div`
  ${media.phone`
    width: 100%;
    max-width: 410px;
  `}
  display: inline-block;
  padding-bottom: 24px;
`;

export const Title = styled(TituloPrincipal)`
  color: ${(props) => props.cor};
  line-height: 42px;
  padding-top: 10px;
  font-weight: 500;
  ${media.desktop`
    padding-top: 0;
  `}
  ${media.phone`
    line-height: 33px;
    font-size: 28px;
  `}
`;

export const ContainerCTA = styled.div`
  button {
    ${media.phone`
      min-width: 6.75rem;
      width: 114px;
      height: 3.1rem;
      &:hover{
        height: 3.2rem;
        min-width: 7.25rem;
        padding: 0;
      }
    `}
    font-family: ${fontFamily.neutral};
    font-weight: 700;
    min-width: 7.75rem;
    width: 130px;
    height: 3.3rem;
    padding: 0;
      &:hover{
        height: 3.5rem;
        min-width: 8.25rem;
        padding: 0;
      }
  }
`;
